module.exports = __webpack_public_path__ + "static/media/fantasyomatic-ui-paywall-Artboard-5@2x.68a92be4.png";